import { getConfiguration } from "@chr/common-web-ui-configuration";
import { datadogRum } from "@datadog/browser-rum";
import { AccountsUIAppConfig } from "./react-app-env";
import { initFullStoryUser } from "./app/common/utils";

export const index: Promise<void> = (async () => {
  const config = await getConfiguration<AccountsUIAppConfig>();

  try {
    datadogRum.init({
      applicationId: "1249a076-7879-4c3b-a446-2fbf40fb6761",
      clientToken: "pube23d8b731ac7cfaf0d6d23a87db50dcd",
      site: "us3.datadoghq.com",
      sampleRate: 50,
      premiumSampleRate: 40,
      env: config.environment,
      service: "SmallBusiness.Acounts.UI",
      version: "1.0.0",
      trackInteractions: true,
      useSecureSessionCookie: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    // if the user logged in then we receive user data and can set user id for fullstory, otherwise we will set it in the sign in page
    initFullStoryUser();
  } catch {
    // Do not block loading for a datadog error
  }

  const { bootstrap } = await import("./bootstrap");
  void bootstrap(config);
})();
